import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { store } from '@/state/store';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { LOCAL__ui_set_string, store_local__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

export function FN_FIELD_IMAGE__edit(field: FIELD__image_asset, layout: ENUM__page_generation_layout, tab: ENUM__page_generation_layout_images_edit_tab) {
  store.dispatch(LOCAL__ui_set_string({ key: 'g_general__layout', value: layout, valid_values: [] }));
  store.dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__tab', value: tab, valid_values: [] }));

  store.dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field }));

  if (field.is_stub() || field.asset.is_stub()) {
    store.dispatch(LOCAL__ui_set_image({ key: 'g_image_edit__select__image_asset', value: field.asset }));
  } else {
    LOCAL__ui_set_image({ key: 'g_image_edit__select__image_asset', value: field.asset });

    const workspace_id = store.getState().slice_workspace.workspace_current._id;

    store_local__ui_set_string({ key: 'g_image_edit__replace__category', value: field.category, valid_values: [] });
    store_local__ui_set_string({ key: 'g_image_edit__replace__workspace_id', value: workspace_id, valid_values: [] });

    UTILS__graph_ui.node__select(field.meta.node_id);
  }
}
